import CoconeuseBioTemplate from "../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseDeborah = () => (
  <CoconeuseBioTemplate
    name="Deborah"
    subtitle="Éveil · Harmonisation · Paix intérieure · Transformation"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/6r9rpmdm_DSC01487.jpg"
    bioText={[
      "Deborah est un pont entre l'universel et l'intime.",
      "Elle explore les profondeurs de l'âme et les mondes subtils pour révéler la lumière intérieure propre à chacun·e.",
      "Animée par la transformation énergétique, elle accompagne celles et ceux qui souhaitent se libérer de schémas anciens, apaiser leur monde intérieur et incarner pleinement leur potentiel.",
    ]}
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/aktwmscl_DSC00955.jpg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/44b3o3mj_DSC01494.jpg",
      "https://customer-assets.emergentagent.com/job_ab90437d-48ff-4ccd-a516-a405b584e6a2/artifacts/0n2btygx_DSC02699%20%281%29.jpg",
    ]}
    expertise={["Transformation énergétique", "Compréhension du mental", "Éveil intérieur"]}
  />
);

export default CoconeuseDeborah;
